"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_9 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const permissionStore_1 = require("../../stores/permission/permissionStore");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const userGroupStore_1 = require("../../stores/userGroup/userGroupStore");
const UserGroupRequest_1 = __importDefault(require("../../stores/userGroup/UserGroupRequest"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminUserGroups',
    setup(__props) {
        var _a, _b, _c;
        const T = (0, vue_3.inject)("Translator");
        const errorMessage = (0, vue_3.ref)("");
        const router = (0, vue_router_1.useRouter)();
        const permissionStore = (0, permissionStore_1.usePermissionStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const userGroupStore = (0, userGroupStore_1.useUserGroupStore)();
        const userGroupRequest = (0, vue_3.ref)(new UserGroupRequest_1.default());
        const selectedUserGroup = (0, vue_3.ref)(null);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const modalIsOpen = (0, vue_3.ref)(false);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = T === null || T === void 0 ? void 0 : T.trans("id", "ID", "user_groups")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "key",
                label: (_b = T === null || T === void 0 ? void 0 : T.trans("key", "Key", "user_groups")) !== null && _b !== void 0 ? _b : "Key",
                value: "key",
                filterable: true,
                sortable: true,
            },
            {
                key: "name",
                label: (_c = T === null || T === void 0 ? void 0 : T.trans("name", "Name", "user_groups")) !== null && _c !== void 0 ? _c : "Name",
                value: "name",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        (0, vue_3.onBeforeMount)(() => {
            userGroupStore
                .getUserGroups(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            permissionStore.getPermissions(router, {
                "order[group]": "asc",
                "order[key]": "asc",
            });
        });
        (0, vue_3.onBeforeUnmount)(() => {
            userGroupStore.userGroups = [];
        });
        const openCreateUserGroupModal = () => {
            userGroupRequest.value = new UserGroupRequest_1.default();
            selectedUserGroup.value = null;
            modalIsOpen.value = true;
        };
        const openUpdateUserModal = (userGroup) => {
            selectedUserGroup.value = userGroup;
            userGroupRequest.value = new UserGroupRequest_1.default(userGroup.name, userGroup.key, userGroup.permissions.map((permission) => permission["@id"]));
            modalIsOpen.value = true;
        };
        const deleteUserGroup = (userGroup) => {
            if (!confirm(T === null || T === void 0 ? void 0 : T.trans("delete_user_group_confirm", "Are you sure?", "user_groups"))) {
                return;
            }
            errorMessage.value = "";
            userGroupStore
                .deleteUserGroup(router, userGroup.id)
                .then(() => {
                userGroupStore.userGroups = [];
                userGroupStore
                    .getUserGroups(router)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const permissionCheckboxChange = (checked, permission) => {
            if (checked &&
                userGroupRequest.value.permissions.findIndex((permissionIri) => permissionIri === permission["@id"]) === -1) {
                userGroupRequest.value.permissions.push(permission["@id"]);
                return;
            }
            if (!checked &&
                userGroupRequest.value.permissions.findIndex((permissionIri) => permissionIri === permission["@id"]) !== -1) {
                userGroupRequest.value.permissions =
                    userGroupRequest.value.permissions.filter((permissionIri) => permission["@id"] !== permissionIri);
            }
        };
        const createUserGroup = () => {
            errorMessage.value = "";
            userGroupStore
                .createUserGroup(router, userGroupRequest.value)
                .then(() => {
                modalIsOpen.value = false;
                userGroupStore.userGroups = [];
                page.value = 1;
                userGroupStore
                    .getUserGroups(router, userGroupQuery.value)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const updateUserGroup = () => {
            var _a;
            errorMessage.value = "";
            if (selectedUserGroup.value === null) {
                errorMessage.value =
                    (_a = T === null || T === void 0 ? void 0 : T.trans("userGroup_not_selected", "UserGroup not selected", "userGroups")) !== null && _a !== void 0 ? _a : "UserGroup not selected";
                return;
            }
            userGroupStore
                .updateUserGroup(router, userGroupRequest.value, selectedUserGroup.value.id)
                .then(() => {
                modalIsOpen.value = false;
                userGroupStore.userGroups = [];
                page.value = 1;
                userGroupStore
                    .getUserGroups(router, userGroupQuery.value)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
            }
        });
        const userGroupQuery = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.watchEffect)(() => {
            userGroupStore
                .getUserGroups(router, userGroupQuery.value)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (openCreateUserGroupModal()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("add_user_group_button", "Add User Group", "user_groups")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    items: (0, vue_2.unref)(userGroupStore).userGroups,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    "is-busy": (0, vue_2.unref)(userGroupStore).loading
                }, {
                    "cell-actions": (0, vue_2.withCtx)(({ item: userGroup }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary btn-link",
                                onClick: ($event) => (openUpdateUserModal(userGroup))
                            }, [
                                _hoisted_6,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("edit", "Edit", "user_groups")), 1)
                            ], 8, _hoisted_5),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-danger btn-link",
                                onClick: ($event) => (deleteUserGroup(userGroup))
                            }, [
                                _hoisted_8,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("delete", "Delete", "user_groups")), 1)
                            ], 8, _hoisted_7)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "sortBy", "sortDesc", "items", "is-busy"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    "is-open": modalIsOpen.value,
                    title: selectedUserGroup.value !== null
                        ? _ctx.$trans('edit_user_group_modal_title', 'Edit User Group: {group}', 'user_groups', { group: selectedUserGroup.value.name })
                        : _ctx.$trans('add_user_group', 'Add User Group', 'user_groups'),
                    onClose: _cache[7] || (_cache[7] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: _ctx.$trans('save_error', 'Save error', 'user_groups'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: userGroupRequest.value.name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((userGroupRequest.value.name) = $event)),
                            placeholder: _ctx.$trans('user_group_name_placeholder', 'User Group Name', 'user_groups'),
                            label: _ctx.$trans('user_group_name_label', 'User Group Name', 'user_groups'),
                            autofocus: "",
                            required: "",
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: userGroupRequest.value.key,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((userGroupRequest.value.key) = $event)),
                            placeholder: _ctx.$trans('user_group_key_placeholder', 'User Group Key', 'user_groups'),
                            label: _ctx.$trans('user_group_key_label', 'User Group Key', 'user_groups'),
                            required: "",
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(permissionStore).permissionGroupped, (permissions, group) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                                key: group,
                                fields: [{ key: 'group', label: group, value: '' }],
                                items: permissions,
                                striped: "",
                                condensed: "",
                                class: "mt-4",
                                "is-busy": (0, vue_2.unref)(permissionStore).loading
                            }, {
                                "cell-group": (0, vue_2.withCtx)(({ item: permission }) => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                        label: permission.description,
                                        checked: userGroupRequest.value.permissions.findIndex((permissionIri) => permissionIri === permission['@id']) !== -1,
                                        reversed: "",
                                        onChange: checked => { permissionCheckboxChange(checked, permission); }
                                    }, null, 8, ["label", "checked", "onChange"])
                                ]),
                                _: 2
                            }, 1032, ["fields", "items", "is-busy"]));
                        }), 128)),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-primary",
                                onClick: _cache[6] || (_cache[6] = ($event) => (selectedUserGroup.value === null
                                    ? createUserGroup()
                                    : updateUserGroup()))
                            }, [
                                _hoisted_10,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("save", "Save", "user_groups")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["is-open", "title"])
            ]));
        };
    }
});
